module.exports = __webpack_public_path__ + "media/img/payment-methods/maestro-old-3f836aacacecbc5f2fb985db4663f361.svg";